<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active">
                <i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="container-fluid">
        <b-row class="col-lg-12">
          <div class="col-lg-3 col-md-3 col-sm-12">
            <b-form-group
              label-cols-lg="3"
              :label-for="'provider-id-filter-input'"
              label="Select Provider"
            >
              <multiselect
                v-model="filters.providerId"
                :options="providerOptions"
                label="label"
                track-by="value"
                :multiple="false"
                :placeholder="'Select Provider'"
              />
            </b-form-group>
          </div>
        </b-row>

        <div class="row col-lg-12">
          <div class="form-group col-sm-2">
            <EditForm
              :default-values="{}"
              title="Create Game"
              @finish="handleItemsUpdate"
              create
            >
              <template #button="{ onclick }">
                <b-button type="button" variant="success" @click="onclick"
                  ><i class="fas fa-plus"></i> Create</b-button
                >
              </template>
            </EditForm>
          </div>
        </div>

        <div class="row col-12" id="loading-container">
          <div class="col-12 mb-10">
            <div class="mb-10">
              <div class="table-wrapper mb-10">
                <b-table
                  :striped="true"
                  :small="true"
                  :hover="true"
                  :empty-text="emptyText"
                  show-empty
                  :busy="!!cancel"
                  :items="filteredItems"
                  :fields="fields"
                >
                  <template #cell(actions)="row">
                    <EditForm
                      :default-values="{ ...row.item }"
                      title="Edit Game"
                      @finish="handleItemsUpdate"
                    />
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import EditProviderGameForm from '../../components/ProviderGames/EditProviderGameForm.vue'
import axios from 'axios'
import { getRouteIcon, ROUTE_AGGR_CONFIGS } from '../../utils/routerIcons'
import FilterButtons from '../../components/FilterButtons.vue'
import Multiselect from 'vue-multiselect'
import { ProvidersIds } from '../../definitions/ProviderID'

export default {
  components: {
    EditForm: EditProviderGameForm,
    FilterButtons,
    Multiselect
  },
  data() {
    return {
      showEmpty: false,
      showError: false,
      cancel: null,
      error: null,
      fields: [
        { key: 'id', label: '_ID' },
        { key: 'providerId', label: 'Provider' },
        { key: 'name', label: 'Name' },
        { key: 'fullName', label: 'Full Name' },
        { key: 'gameId', label: 'Game ID' },
        { key: 'tableId', label: 'Table ID' },
        { key: 'developer', label: 'Developer' },
        { key: 'rtp', label: 'RTP' },
        { key: 'hidden', label: 'Hidden' },
        { key: 'opened', label: 'Opened' },
        { key: 'actions', label: 'Actions' }
      ],
      items: [],
      filters: {
        providerId: null
      }
    }
  },
  computed: {
    providerOptions() {
      return ProvidersIds.map(item => {
        return { label: item, value: item }
      })
    },
    emptyText() {
      if (this.cancel) {
        return 'Loading items..'
      }

      if (this.error) {
        return this.error
      }

      return 'There are no records to show'
    },
    routeIcon: () => getRouteIcon(ROUTE_AGGR_CONFIGS),
    filteredItems() {
      if (this.filters.providerId === null) {
        return this.items
      }
      return this.items.filter(
        item => item.providerId === this.filters.providerId.value
      )
    }
  },
  methods: {
    handleItemsUpdate() {
      this.loadItems()
    },
    loadItems() {
      let loadingInstance = this.$veLoading({
        target: document.querySelector('#loading-container'),
        name: 'wave'
      })

      this.items = []

      let self = this
      loadingInstance.show()

      this.$http({
        url: '/api/v1/provider-games',
        method: 'GET',
        cancelToken: new axios.CancelToken(c => {
          self.cancel = c
        })
      })
        .then(resp => {
          this.items = resp.data
        })
        .catch(err => {
          this.items = []
          this.error = err
        })
        .finally(() => {
          loadingInstance.close()
          this.cancel = null
        })
    },
    cancelRequest() {
      if (this.cancel) {
        this.cancel('this -> cancel previous request')
      }
    },
    onFinishEdit() {
      this.loadItems()
    }
  },
  mounted() {
    this.loadItems()
  }
}
</script>
